import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { faqs } from '../mock';
import Reveal from './Reveal';

const Faqs = () => {
  const [open, setOpen] = useState(0);
  return (
    <section id="faqs" className="bg-white py-24">
      <div className="max-w-[900px] mx-auto px-6">
        <Reveal variant="up">
          <div className="text-center mb-12">
            <div className="text-[#D4A853] tracking-[0.3em] text-xs font-semibold mb-3">FAQS</div>
            <h2 className="text-3xl md:text-4xl font-bold text-[#0B1430]">Frequently Asked Questions</h2>
          </div>
        </Reveal>
        <div className="space-y-3">
          {faqs.map((f, i) => (
            <Reveal key={f.q} variant="up" delay={i * 80}>
              <div className="border border-gray-200 rounded-lg overflow-hidden bg-white">
                <button
                  onClick={() => setOpen(open === i ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left hover:bg-[#FBF3E2]/40 transition-colors"
                >
                  <span className="font-semibold text-[#0B1430] text-[15px]">{f.q}</span>
                  <ChevronDown size={18} className={`text-[#D4A853] transition-transform shrink-0 ${open === i ? 'rotate-180' : ''}`} />
                </button>
                <div className={`px-5 overflow-hidden transition-all ${open === i ? 'max-h-40 py-3' : 'max-h-0 py-0'}`}>
                  <p className="text-gray-600 text-[14px] leading-relaxed">{f.a}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Faqs;
